import React, { useEffect, useState } from 'react';

const PlanterGardenImageComponent = ({ gardenMatrix, customSize, dashboard }) => {
    const [normalizedMatrix, setNormalizedMatrix] = useState([]);

    function normalizeArray(dataString) {
        let array = dataString.trim().split("\n").map(row => row.split(",").map(Number));
        array = array.filter(row => row.some(value => value !== 0));
        let transposed = array[0].map((_, colIndex) => array.map(row => row[colIndex]));
        transposed = transposed.filter(col => col.some(value => value !== 0));
        return transposed[0].map((_, rowIndex) => transposed.map(col => col[rowIndex]));
    }

    useEffect(() => {
        setNormalizedMatrix(normalizeArray(gardenMatrix));
    }, [gardenMatrix]);

    const containerSize = customSize || 150;
    const rows = normalizedMatrix.length || 1;
    const cols = normalizedMatrix[0]?.length || 1;
    const cellSize = Math.floor(containerSize / Math.max(rows, cols));

    const getOutlineStyle = (value) => {
        if (value !== 1) return {};

        return {
            backgroundColor: "#6d4c41",
            outline: "1px solid #5c4037",
            outlineOffset: "-1px",
        };
    };

    return (
        <div className="planter-garden-image"
             style={{
                 width: containerSize,
                 height: containerSize,
                 border: dashboard ? "3px solid #065d44" : "transparent",
             }}
        >
            <div
                className="planter-garden-image-matrix"
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${cols}, ${cellSize}px)`,
                    gridTemplateRows: `repeat(${rows}, ${cellSize}px)`,
                    gap: "0px",
                    width: `${cellSize * cols}px`,
                    height: `${cellSize * rows}px`,
                    backgroundColor: "transparent",
                }}
            >
                {normalizedMatrix.map((row, rowIndex) =>
                    row.map((value, colIndex) => (
                        <div
                            key={`${rowIndex}-${colIndex}`}
                            style={{
                                width: `${cellSize}px`,
                                height: `${cellSize}px`,
                                ...getOutlineStyle(value),
                            }}
                        ></div>
                    ))
                )}
            </div>
        </div>
    );
};

export default PlanterGardenImageComponent;